import { render, staticRenderFns } from "./kanbanRenovacao.vue?vue&type=template&id=ce95a9be"
import script from "./kanbanRenovacao.vue?vue&type=script&lang=js"
export * from "./kanbanRenovacao.vue?vue&type=script&lang=js"
import style0 from "./kanbanRenovacao.vue?vue&type=style&index=0&id=ce95a9be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports